
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.34619',
  depVersions: {
  "documents-public-ui": "static-1.34619",
  "atom": "static-1.5112",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2536",
  "client-types": "static-1.471",
  "cssUtils": "static-1.799",
  "customer-data-filters-ui": "static-1.39947",
  "customer-data-objects": "static-1.7712",
  "customer-data-property-utils": "static-1.8129",
  "documents-lib": "static-1.34624",
  "emoji-mart": "static-3.4",
  "flux-actions": "static-1.341",
  "FormsCommonComponents": "static-1.85969",
  "FormUrlGenerator": "static-2.4757",
  "foundations-theming-specialty": "static-1.2173",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.5007",
  "highcharts": "static-8.104",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5628",
  "hs-test-utils": "static-1.8053",
  "hub-http": "static-1.6260",
  "hubspot-dlb": "static-2.1854",
  "HubStyle": "static-2.11818",
  "HubStyleTokens": "static-2.11511",
  "I18n": "static-7-hdineen_hubspot-i18n-react-compiler.2",
  "icons": "static-2.650",
  "jasmine-immutable": "static-1.3058",
  "jasmine-runner": "static-1.6501",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7194",
  "lodash": "static-1.3",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "property-translator": "static-1.5436",
  "quartz": "static-1.7079",
  "react": "static-7.186",
  "react-dlb": "static-1.79",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.71",
  "react-rhumb": "static-1.16712",
  "react-select-plus": "static-1.105",
  "react-utils": "static-2.5373",
  "react-virtualized": "static-2.99",
  "reference-resolvers": "static-1.8209",
  "reference-resolvers-lite": "static-1.8134",
  "reporting-data": "static-1.67731",
  "reporting-reports": "static-1.67409",
  "reporting-snowflake": "static-1.56349",
  "reporting-testing-lib": "static-1.9664",
  "reporting-visualizations": "static-1.59807",
  "reselect": "static-2.16",
  "sales-content-partitioning": "static-1.8981",
  "sanitize": "static-1.4514",
  "sanitize-text": "static-1.8180",
  "self-service-api": "static-1.10285",
  "SharedI18nStrings": "static-1.182",
  "SharedLegalStrings": "static-1.1785",
  "signup-constants": "static-1.18914",
  "signup-ui-url-generator": "static-2.8092",
  "StyleGuideUI": "static-3.488",
  "superstore": "static-1.4798",
  "tinymce": "static-6.5",
  "transmute": "static-2.85",
  "ui-addon-draggable": "static-3.4800",
  "ui-addon-form-validation": "static-1.11027",
  "ui-asset-management-lib": "static-1.11089",
  "ui-images": "static-2.1161",
  "UIComponents": "static-3.8457",
  "usage-tracker": "static-1.7386",
  "usage-tracker-container": "static-1.7376",
  "usage-tracker-core": "static-1.7236",
  "viral-links-lib": "static-1.7106",
  "webpack-env": "static-1.54",
  "data-fetching-client": "static-1.9704",
  "foundations-components": "static-1.8008",
  "immutable": "static-2.79",
  "isMobile": "static-1.7",
  "PortalIdParser": "static-2.404",
  "quartz-config": "static-1.857",
  "quartz-core": "static-1.6298",
  "quick-fetch": "static-1.3946",
  "raven": "static-3.5925",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "rpc-client-utils": "static-1.4690",
  "ui-addon-i18n": "static-1.11188",
  "ui-addon-upgrades": "static-9.18054",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4132",
  "metrics-js": "static-1.9637",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3428",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3356",
  "quartz-webpack": "static-1.3303",
  "foundations-assets": "static-1.4906",
  "foundations-theming": "static-1.4457",
  "hub-http-shared-msw-handlers": "static-1.10060",
  "hubspotter-http": "static-1.4680",
  "sassPrefix": "static-1.156",
  "events-data-lib": "static-1.264",
  "conversations-skeleton-state": "static-1.7286",
  "crm-message-bus": "static-1.43081",
  "customer-data-filters-ui-msw-helpers": "static-1.22382",
  "customer-data-objects-ui-components": "static-1.13068",
  "customer-data-reference-ui-components": "static-1.13205",
  "customer-data-ui-utilities": "static-1.9864",
  "framework-builder-read-service-client": "static-1.4034",
  "framework-data-schema-quick-fetch": "static-1.6829",
  "framework-data-schema-resolvers": "static-1.6924",
  "inbound-db-meta-service-client": "static-1.3615",
  "inbound-db-properties-service-client": "static-1.3875",
  "multi-account-reference-resolvers": "static-1.1018",
  "onboarding-tours": "static-1.16677",
  "reporting-datasets-permissions-lib": "static-1.13800",
  "ui-addon-teams": "static-1.21610",
  "quartz-auth": "static-1.754",
  "ui-business-units-lib": "static-1.9094",
  "usage-tracker-session-replay": "static-1.5072",
  "ai-components-ui-library": "static-1.9071",
  "ContentUtils": "static-1.68488",
  "customer-data-properties": "static-1.51710",
  "forms-ai-lib": "static-1.4376",
  "forms-utils-lib": "static-1.12657",
  "foundations-components-test-utils": "static-1.5491",
  "react-dnd-compat": "static-1.4652",
  "react-tinymce": "static-1.55361",
  "tinymce-config": "static-2.54487",
  "ui-gdpr-components": "static-1.10388",
  "underscore": "static-1.8",
  "foundations-theming-base": "static-1.3442",
  "HeadJS": "static-2.765",
  "framer-motion": "static-1.72",
  "hs-test-utils-bend-plugin": "static-1.3164",
  "msw": "static-1.39",
  "testing-library": "static-1.152",
  "hs-locale-management": "static-1.110",
  "ui-fonts": "static-1.773",
  "i18n-data": "static-1.222",
  "moment-timezone": "static-5.83",
  "jasmine": "static-4.4364",
  "csstype": "static-1.50",
  "quartz-head": "static-1.744",
  "web-vitals": "static-1.6",
  "batch-promise": "static-1.1579",
  "external-options-client-types": "static-1.4189",
  "fast-json-stable-stringify": "static-1.4",
  "quartz-i18n": "static-1.754",
  "frontend-preferences-client": "static-1.7965",
  "graphql": "static-1.82",
  "immer": "static-1.33",
  "persist-promise": "static-1.3736",
  "reporting-client-types": "static-1.2514",
  "apollo-stack-hubspot": "static-3.86",
  "growth-payments-core": "static-1.25501",
  "hubspot-apollo-client": "static-1.4916",
  "foundations-components-legacy": "static-1.1033",
  "merchandise-lib": "static-1.264",
  "quartz-routing": "static-1.509",
  "hs-story-utils": "static-1.9461",
  "react-flip-move": "static-1.70",
  "nested-table": "static-1.264",
  "timezone-utils": "static-2.5282",
  "seat-types-lib": "static-1.110",
  "bend-plugin-foundations-components": "static-1.4277",
  "floating-ui": "static-1.56",
  "react-aria": "static-1.66",
  "react-create-root-preference": "static-1.30",
  "tanstack-table": "static-1.55",
  "trellis-assets": "static-1.2046",
  "dispatcher": "static-1.137",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.839",
  "mobile-manifest-mixins": "static-1.539",
  "module-federation": "static-1.23",
  "quartz-test": "static-1.754",
  "quartz-tracking": "static-1.458",
  "bend-plugin-chirp-manifest": "static-1.100",
  "chirp-fetch": "static-1.1925",
  "purchase-motions-components": "static-1.5988",
  "salesImages": "static-1.525",
  "ts-schema": "static-1.4109",
  "bender-build-tools": "static-1.3227",
  "bend-plugin-foundations-theming": "static-1.2940",
  "stylex": "static-1.33",
  "hs-resources": "static-1.195",
  "pulse": "static-1.618",
  "restore-request-side-panel-lib": "static-1.1014",
  "react-immutable-render-mixin": "static-1.9",
  "conditional-properties-service-client": "static-1.3827",
  "crm-pipelines-api-client-types": "static-1.4169",
  "fdsr-migration-layer": "static-1.43",
  "multi-currency-client-types": "static-1.3721",
  "getting-started-shared-tasks": "static-1.18556",
  "growth-data-modal": "static-1.5487",
  "growth-onboarding-confetti": "static-1.3105",
  "growth-onboarding-next-action-utils": "static-1.2043",
  "navigation-components": "static-1.18143",
  "onboarding-tours-client": "static-1.4891",
  "onboarding-tours-utils": "static-1.743",
  "ui-shepherd-react": "static-3.10228",
  "ui-shepherd-tracker": "static-1.7609",
  "ui-universal-auth": "static-1.9022",
  "user-context": "static-1.5144",
  "hubspotter-http-shared-msw-handlers": "static-1.10058",
  "magpie-lib": "static-1.5575",
  "navigation-messaging": "static-1.7470",
  "amplitude-session-replay-browser": "static-1.61",
  "chatspot-core": "static-1.21461",
  "copilot-toolkit": "static-1.11236",
  "cms-field-types": "static-1.4850",
  "content-icons-ui": "static-1.2234",
  "integrations-lib": "static-1.16302",
  "calling-global-api": "static-1.64658",
  "calling-internal-common": "static-1.31341",
  "calling-lifecycle-internal": "static-1.66040",
  "calling-lifecycle-messages": "static-1.58334",
  "commerce-products-lib": "static-1.9717",
  "crm-links": "static-1.6340",
  "customer-data-properties-shared-msw-handlers": "static-1.9387",
  "file-manager-components": "static-1.23732",
  "google-libphonenumber": "static-1.38",
  "inbounddb-objects-service-types": "static-1.4252",
  "meetings-icalendar-utils-lib": "static-1.669",
  "object-builder-ui-client": "static-1.48886",
  "pipeline-validation-client-types": "static-1.3994",
  "property-value-citations": "static-1.2324",
  "smart-property-lib": "static-1.7299",
  "tiered-pricing": "static-1.1307",
  "zustand": "static-1.74",
  "ui-addon-iframeable": "static-1.9098",
  "final-form": "static-1.70",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.19899",
  "tinymce-themes": "static-1.56457",
  "data-token-picker": "static-1.16473",
  "hub-http-contrib": "static-1.3079",
  "interframe": "static-3.4797",
  "tinymce-data": "static-1.40572",
  "tinymce-plugins": "static-1.57601",
  "ui-addon-sales-email": "static-1.5249",
  "onboarding-scopes": "static-1.6499",
  "ui-addon-opt": "static-4.8401",
  "apollo-link-hub-http": "static-2.4689",
  "hubspot-apollo-cache": "static-1.375",
  "react-window": "static-1.13",
  "ts-utils-lib": "static-1.209",
  "purchase-motions-api": "static-1.5991",
  "bend-plugin-pulse": "static-1.121",
  "event-emitter": "static-1.985",
  "fast-json-patch": "static-1.63",
  "onboarding-data-sync-lib": "static-1.2017",
  "growth-onboarding-next-action-components": "static-1.2071",
  "user-context-client": "static-1.4650",
  "idb-keyval": "static-1.44",
  "magpie-types": "static-1.5035",
  "nest": "static-1.268",
  "reactive-lib": "static-1.761",
  "simple-logging-lib": "static-1.3089",
  "unified-auth-core-lib": "static-1.818",
  "getting-started-shared-tasks-store": "static-1.17674",
  "markdown-it": "static-1.6",
  "breeze-engine-lib": "static-1.777",
  "integrations-error-boundary-lib": "static-1.13717",
  "integrations-tracking-lib": "static-1.5640",
  "native-integrations-shared-strings": "static-1.7819",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10403",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.536",
  "calling-error-reporting": "static-1.31348",
  "shared-worker-versioning": "static-1.11073",
  "calling-usage-tracker": "static-1.6578",
  "voice-sms-access-library": "static-1.1176",
  "customer-data-tracking": "static-1.6927",
  "commerce-permissions": "static-1.811",
  "products-iframe-lib": "static-1.8053",
  "products-ui-components-shared-msw-handlers": "static-1.10442",
  "location-customization-utils-lib": "static-1.9386",
  "apollo-dlb": "static-3.86",
  "immerable": "static-1.4192",
  "video-components-external": "static-1.11431",
  "video-data-lib": "static-1.35089",
  "data-agent-kit": "static-1.254",
  "feedback-loader": "static-1.29369",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10143",
  "fsm": "static-1.3769",
  "policy-lib": "static-1.6814",
  "react-colorpicker": "static-2.10246",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10206",
  "FileManagerLib": "static-1.39372",
  "NamespacedHubStyle": "static-2.9088",
  "FileManagerCore": "static-1.39231",
  "codemirror": "static-5.95",
  "content-assistance-lib": "static-1.7810",
  "layout-dnd-components": "static-1.12516",
  "layout-dnd-utils": "static-1.11491",
  "react-codemirror": "static-1.10665",
  "ui-addon-emoji-picker": "static-1.9925",
  "ui-brand-identity-lib": "static-1.15447",
  "InboxConnectUtils": "static-4.14930",
  "meetings-connect-utils-lib": "static-1.7642",
  "breeze-engine-core": "static-1.55",
  "ably": "static-2.2",
  "highlight.js": "static-1.79",
  "universal-page-editor-lib": "static-1.3052",
  "google-sheets-integration-lib": "static-1.363",
  "microsoft-drive-integration-lib": "static-1.490",
  "slack-ui-library": "static-1.10430",
  "calling-orchestration-schema": "static-1.35953",
  "sales-views-client-types": "static-1.4297",
  "crm-record-cards-service-types": "static-1.3618",
  "content-media-composition-data-lib": "static-1.12472",
  "content-media-compositions": "static-2.16479",
  "media-bridge-lib": "static-1.18993",
  "trellis-story-utils": "static-1.4552",
  "storybook-react": "static-1.33",
  "audio-components": "static-1.5973",
  "FileManagerImages": "static-1.36883",
  "video-components": "static-1.13433",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4575",
  "video-embed": "static-1.35923",
  "diff-match-patch": "static-1.7",
  "ui-addon-video-player": "static-1.8741",
  "ui-coaching-tips": "static-1.28679",
  "ContentData": "static-1.68563",
  "layout-data-lib": "static-1.9816",
  "browser-eslint": "static-2.57",
  "social-insights-client-types": "static-1.22224",
  "outpost": "static-1.4216",
  "growth-onboarding-feedback-components": "static-1.6617",
  "advanced-menus-core": "static-1.15187",
  "advanced-menus-lib": "static-1.12125",
  "ExportDialog": "static-6.10423",
  "ui-memberships-settings-lib": "static-1.34164",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15186",
  "simple-menus-lib": "static-1.16703"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.34619",
  "atom": "/atom/static-1.5112",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2536",
  "client-types": "/client-types/static-1.471",
  "cssUtils": "/cssUtils/static-1.799",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39947",
  "customer-data-objects": "/customer-data-objects/static-1.7712",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8129",
  "documents-lib": "/documents-lib/static-1.34624",
  "emoji-mart": "/emoji-mart/static-3.4",
  "flux-actions": "/flux-actions/static-1.341",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85969",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4757",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2173",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.5007",
  "highcharts": "/highcharts/static-8.104",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5628",
  "hs-test-utils": "/hs-test-utils/static-1.8053",
  "hub-http": "/hub-http/static-1.6260",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "HubStyle": "/HubStyle/static-2.11818",
  "HubStyleTokens": "/HubStyleTokens/static-2.11511",
  "I18n": "/I18n/static-7-hdineen_hubspot-i18n-react-compiler.2",
  "icons": "/icons/static-2.650",
  "jasmine-immutable": "/jasmine-immutable/static-1.3058",
  "jasmine-runner": "/jasmine-runner/static-1.6501",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7194",
  "lodash": "/lodash/static-1.3",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "property-translator": "/property-translator/static-1.5436",
  "quartz": "/quartz/static-1.7079",
  "react": "/react/static-7.186",
  "react-dlb": "/react-dlb/static-1.79",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.71",
  "react-rhumb": "/react-rhumb/static-1.16712",
  "react-select-plus": "/react-select-plus/static-1.105",
  "react-utils": "/react-utils/static-2.5373",
  "react-virtualized": "/react-virtualized/static-2.99",
  "reference-resolvers": "/reference-resolvers/static-1.8209",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8134",
  "reporting-data": "/reporting-data/static-1.67731",
  "reporting-reports": "/reporting-reports/static-1.67409",
  "reporting-snowflake": "/reporting-snowflake/static-1.56349",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.9664",
  "reporting-visualizations": "/reporting-visualizations/static-1.59807",
  "reselect": "/reselect/static-2.16",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.8981",
  "sanitize": "/sanitize/static-1.4514",
  "sanitize-text": "/sanitize-text/static-1.8180",
  "self-service-api": "/self-service-api/static-1.10285",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1785",
  "signup-constants": "/signup-constants/static-1.18914",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8092",
  "StyleGuideUI": "/StyleGuideUI/static-3.488",
  "superstore": "/superstore/static-1.4798",
  "tinymce": "/tinymce/static-6.5",
  "transmute": "/transmute/static-2.85",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4800",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11027",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11089",
  "ui-images": "/ui-images/static-2.1161",
  "UIComponents": "/UIComponents/static-3.8457",
  "usage-tracker": "/usage-tracker/static-1.7386",
  "usage-tracker-container": "/usage-tracker-container/static-1.7376",
  "usage-tracker-core": "/usage-tracker-core/static-1.7236",
  "viral-links-lib": "/viral-links-lib/static-1.7106",
  "webpack-env": "/webpack-env/static-1.54",
  "data-fetching-client": "/data-fetching-client/static-1.9704",
  "foundations-components": "/foundations-components/static-1.8008",
  "immutable": "/immutable/static-2.79",
  "isMobile": "/isMobile/static-1.7",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "quartz-config": "/quartz-config/static-1.857",
  "quartz-core": "/quartz-core/static-1.6298",
  "quick-fetch": "/quick-fetch/static-1.3946",
  "raven": "/raven/static-3.5925",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "rpc-client-utils": "/rpc-client-utils/static-1.4690",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11188",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18054",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "metrics-js": "/metrics-js/static-1.9637",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3428",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3356",
  "quartz-webpack": "/quartz-webpack/static-1.3303",
  "foundations-assets": "/foundations-assets/static-1.4906",
  "foundations-theming": "/foundations-theming/static-1.4457",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10060",
  "hubspotter-http": "/hubspotter-http/static-1.4680",
  "sassPrefix": "/sassPrefix/static-1.156",
  "events-data-lib": "/events-data-lib/static-1.264",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7286",
  "crm-message-bus": "/crm-message-bus/static-1.43081",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22382",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13068",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13205",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9864",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4034",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6829",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6924",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3615",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3875",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1018",
  "onboarding-tours": "/onboarding-tours/static-1.16677",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13800",
  "ui-addon-teams": "/ui-addon-teams/static-1.21610",
  "quartz-auth": "/quartz-auth/static-1.754",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9094",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5072",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9071",
  "ContentUtils": "/ContentUtils/static-1.68488",
  "customer-data-properties": "/customer-data-properties/static-1.51710",
  "forms-ai-lib": "/forms-ai-lib/static-1.4376",
  "forms-utils-lib": "/forms-utils-lib/static-1.12657",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5491",
  "react-dnd-compat": "/react-dnd-compat/static-1.4652",
  "react-tinymce": "/react-tinymce/static-1.55361",
  "tinymce-config": "/tinymce-config/static-2.54487",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10388",
  "underscore": "/underscore/static-1.8",
  "foundations-theming-base": "/foundations-theming-base/static-1.3442",
  "HeadJS": "/HeadJS/static-2.765",
  "framer-motion": "/framer-motion/static-1.72",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3164",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.152",
  "hs-locale-management": "/hs-locale-management/static-1.110",
  "ui-fonts": "/ui-fonts/static-1.773",
  "i18n-data": "/i18n-data/static-1.222",
  "moment-timezone": "/moment-timezone/static-5.83",
  "jasmine": "/jasmine/static-4.4364",
  "csstype": "/csstype/static-1.50",
  "quartz-head": "/quartz-head/static-1.744",
  "web-vitals": "/web-vitals/static-1.6",
  "batch-promise": "/batch-promise/static-1.1579",
  "external-options-client-types": "/external-options-client-types/static-1.4189",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "quartz-i18n": "/quartz-i18n/static-1.754",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7965",
  "graphql": "/graphql/static-1.82",
  "immer": "/immer/static-1.33",
  "persist-promise": "/persist-promise/static-1.3736",
  "reporting-client-types": "/reporting-client-types/static-1.2514",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.86",
  "growth-payments-core": "/growth-payments-core/static-1.25501",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4916",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1033",
  "merchandise-lib": "/merchandise-lib/static-1.264",
  "quartz-routing": "/quartz-routing/static-1.509",
  "hs-story-utils": "/hs-story-utils/static-1.9461",
  "react-flip-move": "/react-flip-move/static-1.70",
  "nested-table": "/nested-table/static-1.264",
  "timezone-utils": "/timezone-utils/static-2.5282",
  "seat-types-lib": "/seat-types-lib/static-1.110",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4277",
  "floating-ui": "/floating-ui/static-1.56",
  "react-aria": "/react-aria/static-1.66",
  "react-create-root-preference": "/react-create-root-preference/static-1.30",
  "tanstack-table": "/tanstack-table/static-1.55",
  "trellis-assets": "/trellis-assets/static-1.2046",
  "dispatcher": "/dispatcher/static-1.137",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.839",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.539",
  "module-federation": "/module-federation/static-1.23",
  "quartz-test": "/quartz-test/static-1.754",
  "quartz-tracking": "/quartz-tracking/static-1.458",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.100",
  "chirp-fetch": "/chirp-fetch/static-1.1925",
  "purchase-motions-components": "/purchase-motions-components/static-1.5988",
  "salesImages": "/salesImages/static-1.525",
  "ts-schema": "/ts-schema/static-1.4109",
  "bender-build-tools": "/bender-build-tools/static-1.3227",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2940",
  "stylex": "/stylex/static-1.33",
  "hs-resources": "/hs-resources/static-1.195",
  "pulse": "/pulse/static-1.618",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1014",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3827",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4169",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.43",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3721",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18556",
  "growth-data-modal": "/growth-data-modal/static-1.5487",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3105",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2043",
  "navigation-components": "/navigation-components/static-1.18143",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4891",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.743",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10228",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7609",
  "ui-universal-auth": "/ui-universal-auth/static-1.9022",
  "user-context": "/user-context/static-1.5144",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10058",
  "magpie-lib": "/magpie-lib/static-1.5575",
  "navigation-messaging": "/navigation-messaging/static-1.7470",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.61",
  "chatspot-core": "/chatspot-core/static-1.21461",
  "copilot-toolkit": "/copilot-toolkit/static-1.11236",
  "cms-field-types": "/cms-field-types/static-1.4850",
  "content-icons-ui": "/content-icons-ui/static-1.2234",
  "integrations-lib": "/integrations-lib/static-1.16302",
  "calling-global-api": "/calling-global-api/static-1.64658",
  "calling-internal-common": "/calling-internal-common/static-1.31341",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66040",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58334",
  "commerce-products-lib": "/commerce-products-lib/static-1.9717",
  "crm-links": "/crm-links/static-1.6340",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9387",
  "file-manager-components": "/file-manager-components/static-1.23732",
  "google-libphonenumber": "/google-libphonenumber/static-1.38",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4252",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.669",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48886",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3994",
  "property-value-citations": "/property-value-citations/static-1.2324",
  "smart-property-lib": "/smart-property-lib/static-1.7299",
  "tiered-pricing": "/tiered-pricing/static-1.1307",
  "zustand": "/zustand/static-1.74",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9098",
  "final-form": "/final-form/static-1.70",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.19899",
  "tinymce-themes": "/tinymce-themes/static-1.56457",
  "data-token-picker": "/data-token-picker/static-1.16473",
  "hub-http-contrib": "/hub-http-contrib/static-1.3079",
  "interframe": "/interframe/static-3.4797",
  "tinymce-data": "/tinymce-data/static-1.40572",
  "tinymce-plugins": "/tinymce-plugins/static-1.57601",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5249",
  "onboarding-scopes": "/onboarding-scopes/static-1.6499",
  "ui-addon-opt": "/ui-addon-opt/static-4.8401",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4689",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.375",
  "react-window": "/react-window/static-1.13",
  "ts-utils-lib": "/ts-utils-lib/static-1.209",
  "purchase-motions-api": "/purchase-motions-api/static-1.5991",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.121",
  "event-emitter": "/event-emitter/static-1.985",
  "fast-json-patch": "/fast-json-patch/static-1.63",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2017",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2071",
  "user-context-client": "/user-context-client/static-1.4650",
  "idb-keyval": "/idb-keyval/static-1.44",
  "magpie-types": "/magpie-types/static-1.5035",
  "nest": "/nest/static-1.268",
  "reactive-lib": "/reactive-lib/static-1.761",
  "simple-logging-lib": "/simple-logging-lib/static-1.3089",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.818",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17674",
  "markdown-it": "/markdown-it/static-1.6",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.777",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13717",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5640",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7819",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10403",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.536",
  "calling-error-reporting": "/calling-error-reporting/static-1.31348",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11073",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6578",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1176",
  "customer-data-tracking": "/customer-data-tracking/static-1.6927",
  "commerce-permissions": "/commerce-permissions/static-1.811",
  "products-iframe-lib": "/products-iframe-lib/static-1.8053",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10442",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9386",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "immerable": "/immerable/static-1.4192",
  "video-components-external": "/video-components-external/static-1.11431",
  "video-data-lib": "/video-data-lib/static-1.35089",
  "data-agent-kit": "/data-agent-kit/static-1.254",
  "feedback-loader": "/feedback-loader/static-1.29369",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10143",
  "fsm": "/fsm/static-1.3769",
  "policy-lib": "/policy-lib/static-1.6814",
  "react-colorpicker": "/react-colorpicker/static-2.10246",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10206",
  "FileManagerLib": "/FileManagerLib/static-1.39372",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9088",
  "FileManagerCore": "/FileManagerCore/static-1.39231",
  "codemirror": "/codemirror/static-5.95",
  "content-assistance-lib": "/content-assistance-lib/static-1.7810",
  "layout-dnd-components": "/layout-dnd-components/static-1.12516",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11491",
  "react-codemirror": "/react-codemirror/static-1.10665",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9925",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15447",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14930",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7642",
  "breeze-engine-core": "/breeze-engine-core/static-1.55",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.79",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3052",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.363",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.490",
  "slack-ui-library": "/slack-ui-library/static-1.10430",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35953",
  "sales-views-client-types": "/sales-views-client-types/static-1.4297",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3618",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12472",
  "content-media-compositions": "/content-media-compositions/static-2.16479",
  "media-bridge-lib": "/media-bridge-lib/static-1.18993",
  "trellis-story-utils": "/trellis-story-utils/static-1.4552",
  "storybook-react": "/storybook-react/static-1.33",
  "audio-components": "/audio-components/static-1.5973",
  "FileManagerImages": "/FileManagerImages/static-1.36883",
  "video-components": "/video-components/static-1.13433",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4575",
  "video-embed": "/video-embed/static-1.35923",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8741",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28679",
  "ContentData": "/ContentData/static-1.68563",
  "layout-data-lib": "/layout-data-lib/static-1.9816",
  "browser-eslint": "/browser-eslint/static-2.57",
  "social-insights-client-types": "/social-insights-client-types/static-1.22224",
  "outpost": "/outpost/static-1.4216",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6617",
  "advanced-menus-core": "/advanced-menus-core/static-1.15187",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12125",
  "ExportDialog": "/ExportDialog/static-6.10423",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34164",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15186",
  "simple-menus-lib": "/simple-menus-lib/static-1.16703"
}
};
